"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ApiEndpoints_1 = require("../Enum/ApiEndpoints");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
const RestrictedValuationApi_1 = require("../Api/RestrictedValuationApi");
class ApiFactory {
    constructor(containerAwareFactory) {
        this.containerAwareFactory = containerAwareFactory;
    }
    /**
     * @inheritDoc
     */
    create(type, data) {
        switch (type) {
            case ApiEndpoints_1.ApiEndpoints.RESTRICTED_VALUATION: {
                return this.containerAwareFactory.create(RestrictedValuationApi_1.default, data.config);
            }
            default: {
                throw new WidgetError_1.default(`Api with type '${type}' does not exist.`);
            }
        }
    }
}
exports.default = ApiFactory;
